<template>
  <HeroArticle
    :content="content"
    class="HeroProfile"
  >
    <div class="HeroProfile__content">
      <VisionHeading
        v-if="content.title"
        tag="h1"
        class="HeroProfile__title"
      >
        {{ content.title }}
      </VisionHeading>

      <VisionHeading
        v-if="content.sport"
        tag="h2"
        size="h2"
        :class="subtitleClasses"
      >
        <span
          v-if="content.sportSubtitle"
          :class="$b('sport-subtitle')"
        >
          {{ content.sportSubtitle }}
        </span>

        {{ content.sport }}
      </VisionHeading>
    </div>
  </HeroArticle>
</template>

<script>
export default {
  name: 'HeroProfile',

  props: {
    content: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      gradientClassMap: {
        none: '',
        sungod: 't-gradient'
      }
    }
  },

  computed: {
    subtitleClasses () {
      const gradientClass = this.gradientClassMap[this.content.subtitleGradient]

      return {
        HeroProfile__subtitle: true,
        [`${gradientClass}`]: gradientClass
      }
    }
  }
}
</script>

<style lang="postcss">
.HeroProfile__content {
  @apply relative
    flex items-end justify-between
    mdMax:flex-col mdMax:items-start;
}

.HeroProfile__title {
  @apply mb-xxs
    md:mb-xs;

  @screen lg {
    margin-bottom: 4px;
    width: calc((var(--column-width) * 8) + (var(--inner-gutter) * 7));
  }
}

.HeroProfile__subtitle {
  @apply inline-block
    lgMax:mb-xs;

  @screen lg {
    width: calc((var(--column-width) * 4) + (var(--inner-gutter) * 3));
  }
}

.HeroProfile__sport-subtitle {
  @apply block text-md opacity-60;
}
</style>
